var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.withoutButton
    ? _c(
        "div",
        {
          staticClass: "base-btn",
          on: {
            click: function($event) {
              return _vm.action()
            }
          }
        },
        [
          !_vm.withoutArrow
            ? _c("base-icon", {
                staticClass: "mr-2",
                attrs: {
                  src:
                    "/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg",
                  color: "gray",
                  reverse: ""
                }
              })
            : _vm._e(),
          _vm._v(_vm._s(_vm.$t("back")))
        ],
        1
      )
    : _c(
        "base-button",
        {
          attrs: { gray: "", outline: "" },
          on: {
            click: function($event) {
              return _vm.action()
            }
          },
          nativeOn: {
            mouseover: function($event) {
              _vm.hover = true
            },
            mouseleave: function($event) {
              _vm.hover = false
            }
          }
        },
        [
          !_vm.withoutArrow
            ? _c("base-icon", {
                staticClass: "mr-2",
                attrs: {
                  src:
                    "/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg",
                  color: "gray",
                  reverse: ""
                }
              })
            : _vm._e(),
          _vm._v(_vm._s(_vm.$t("back")))
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-88233bf6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88233bf6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/buttons/BackButton.vue
// module id = 1696
// module chunks = 120